const Rooms = {
    "0": {
      "title": "Chile de Arbol Peppers Room",
      "description": "This room is listed at 15,000 – 65,000 on the scoville scale, your discretion is advised",
      "s": [15000, 65000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 1,
      "w_to": 0
    },
    "1": {
      "title": "Habanero Peppers Room",
      "description": "This room is listed at 100,000 – 350,000 on the scoville scale, your discretion is advised",
      "s": [100000, 350000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 2,
      "w_to": 1
    },
    "2": {
      "title": "Habanero Peppers Room",
      "description": "This room is listed at 100,000 – 350,000 on the scoville scale, your discretion is advised",
      "s": [100000, 350000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 3,
      "w_to": 2
    },
    "3": {
      "title": "Jalapeno Room",
      "description": "This room is listed at 2,500 – 8,000 on the scoville scale, your discretion is advised",
      "s": [2500, 8000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 4,
      "w_to": 3
    },
    "4": {
      "title": "Chiltepin Peppers Room",
      "description": "This room is listed at 50,000 – 100,000 on the scoville scale, your discretion is advised",
      "s": [50000, 100000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 5,
      "w_to": 4
    },
    "5": {
      "title": "Cayenne Peppers Room",
      "description": "This room is listed at 30,000 – 50,000 on the scoville scale, your discretion is advised",
      "s": [30000, 50000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 6,
      "w_to": 5
    },
    "6": {
      "title": "Ghost Peppers Room",
      "description": "This room is listed at 1,000,000 on the scoville scale, your discretion is advised",
      "s": [1000000, 1000000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 7,
      "w_to": 6
    },
    "7": {
      "title": "Jalapeno Room",
      "description": "This room is listed at 2,500 – 8,000 on the scoville scale, your discretion is advised",
      "s": [2500, 8000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 8,
      "w_to": 7
    },
    "8": {
      "title": "Chile de Arbol Peppers Room",
      "description": "This room is listed at 15,000 – 65,000 on the scoville scale, your discretion is advised",
      "s": [15000, 65000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 9,
      "w_to": 8
    },
    "9": {
      "title": "Carolina Reaper Chili Pepper Room",
      "description": "This room is listed at 2,200,000+ on the scoville scale, your discretion is advised",
      "s": [2200000, 5000000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 10,
      "w_to": 9
    },
    "10": {
      "title": "Chile de Arbol Peppers Room",
      "description": "This room is listed at 15,000 – 65,000 on the scoville scale, your discretion is advised",
      "s": [15000, 65000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 11,
      "w_to": 10
    },
    "11": {
      "title": "Jalapeno Room",
      "description": "This room is listed at 2,500 – 8,000 on the scoville scale, your discretion is advised",
      "s": [2500, 8000],
      "n_to": 12,
      "s_to": 0,
      "e_to": 0,
      "w_to": 11
    },
    "12": {
      "title": "Ghost Peppers Room",
      "description": "This room is listed at 1,000,000 on the scoville scale, your discretion is advised",
      "s": [1000000, 1000000],
      "n_to": 0,
      "s_to": 12,
      "e_to": 0,
      "w_to": 13
    },
    "13": {
      "title": "Ghost Peppers Room",
      "description": "This room is listed at 1,000,000 on the scoville scale, your discretion is advised",
      "s": [1000000, 1000000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 13,
      "w_to": 14
    },
    "14": {
      "title": "Cayenne Peppers Room",
      "description": "This room is listed at 30,000 – 50,000 on the scoville scale, your discretion is advised",
      "s": [30000, 50000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 0,
      "w_to": 15
    },
    "15": {
      "title": "Chile de Arbol Peppers Room",
      "description": "This room is listed at 15,000 – 65,000 on the scoville scale, your discretion is advised",
      "s": [15000, 65000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 0,
      "w_to": 16
    },
    "16": {
      "title": "Chiltepin Peppers Room",
      "description": "This room is listed at 50,000 – 100,000 on the scoville scale, your discretion is advised",
      "s": [50000, 100000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 0,
      "w_to": 17
    },
    "17": {
      "title": "Serrano Peppers Room",
      "description": "This room is listed at 10,000 – 23,000 on the scoville scale, your discretion is advised",
      "s": [10000, 23000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 0,
      "w_to": 18
    },
    "18": {
      "title": "Serrano Peppers Room",
      "description": "This room is listed at 10,000 – 23,000 on the scoville scale, your discretion is advised",
      "s": [10000, 23000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 0,
      "w_to": 19
    },
    "19": {
      "title": "Chiltepin Peppers Room",
      "description": "This room is listed at 50,000 – 100,000 on the scoville scale, your discretion is advised",
      "s": [50000, 100000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 0,
      "w_to": 20
    },
    "20": {
      "title": "Habanero Peppers Room",
      "description": "This room is listed at 100,000 – 350,000 on the scoville scale, your discretion is advised",
      "s": [100000, 350000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 0,
      "w_to": 21
    },
    "21": {
      "title": "Carolina Reaper Chili Pepper Room",
      "description": "This room is listed at 2,200,000+ on the scoville scale, your discretion is advised",
      "s": [2200000, 5000000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 0,
      "w_to": 22
    },
    "22": {
      "title": "Habanero Peppers Room",
      "description": "This room is listed at 100,000 – 350,000 on the scoville scale, your discretion is advised",
      "s": [100000, 350000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 0,
      "w_to": 23
    },
    "23": {
      "title": "Chiltepin Peppers Room",
      "description": "This room is listed at 50,000 – 100,000 on the scoville scale, your discretion is advised",
      "s": [50000, 100000],
      "n_to": 24,
      "s_to": 0,
      "e_to": 0,
      "w_to": 0
    },
    "24": {
      "title": "Ghost Peppers Room",
      "description": "This room is listed at 1,000,000 on the scoville scale, your discretion is advised",
      "s": [1000000, 1000000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 25,
      "w_to": 0
    },
    "25": {
      "title": "Ghost Peppers Room",
      "description": "This room is listed at 1,000,000 on the scoville scale, your discretion is advised",
      "s": [1000000, 1000000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 26,
      "w_to": 0
    },
    "26": {
      "title": "Carolina Reaper Chili Pepper Room",
      "description": "This room is listed at 2,200,000+ on the scoville scale, your discretion is advised",
      "s": [2200000, 5000000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 27,
      "w_to": 0
    },
    "27": {
      "title": "Cayenne Peppers Room",
      "description": "This room is listed at 30,000 – 50,000 on the scoville scale, your discretion is advised",
      "s": [30000, 50000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 28,
      "w_to": 0
    },
    "28": {
      "title": "Ghost Peppers Room",
      "description": "This room is listed at 1,000,000 on the scoville scale, your discretion is advised",
      "s": [1000000, 1000000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 29,
      "w_to": 0
    },
    "29": {
      "title": "Chiltepin Peppers Room",
      "description": "This room is listed at 50,000 – 100,000 on the scoville scale, your discretion is advised",
      "s": [50000, 100000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 30,
      "w_to": 0
    },
    "30": {
      "title": "Ghost Peppers Room",
      "description": "This room is listed at 1,000,000 on the scoville scale, your discretion is advised",
      "s": [1000000, 1000000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 31,
      "w_to": 0
    },
    "31": {
      "title": "Ghost Peppers Room",
      "description": "This room is listed at 1,000,000 on the scoville scale, your discretion is advised",
      "s": [1000000, 1000000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 32,
      "w_to": 0
    },
    "32": {
      "title": "Ghost Peppers Room",
      "description": "This room is listed at 1,000,000 on the scoville scale, your discretion is advised",
      "s": [1000000, 1000000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 33,
      "w_to": 0
    },
    "33": {
      "title": "Habanero Peppers Room",
      "description": "This room is listed at 100,000 – 350,000 on the scoville scale, your discretion is advised",
      "s": [100000, 350000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 34,
      "w_to": 0
    },
    "34": {
      "title": "Carolina Reaper Chili Pepper Room",
      "description": "This room is listed at 2,200,000+ on the scoville scale, your discretion is advised",
      "s": [2200000, 5000000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 35,
      "w_to": 0
    },
    "35": {
      "title": "Ghost Peppers Room",
      "description": "This room is listed at 1,000,000 on the scoville scale, your discretion is advised",
      "s": [1000000, 1000000],
      "n_to": 36,
      "s_to": 0,
      "e_to": 0,
      "w_to": 0
    },
    "36": {
      "title": "Habanero Peppers Room",
      "description": "This room is listed at 100,000 – 350,000 on the scoville scale, your discretion is advised",
      "s": [100000, 350000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 0,
      "w_to": 37
    },
    "37": {
      "title": "Chile de Arbol Peppers Room",
      "description": "This room is listed at 15,000 – 65,000 on the scoville scale, your discretion is advised",
      "s": [15000, 65000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 0,
      "w_to": 38
    },
    "38": {
      "title": "Carolina Reaper Chili Pepper Room",
      "description": "This room is listed at 2,200,000+ on the scoville scale, your discretion is advised",
      "s": [2200000, 5000000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 0,
      "w_to": 39
    },
    "39": {
      "title": "Serrano Peppers Room",
      "description": "This room is listed at 10,000 – 23,000 on the scoville scale, your discretion is advised",
      "s": [10000, 23000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 0,
      "w_to": 40
    },
    "40": {
      "title": "Serrano Peppers Room",
      "description": "This room is listed at 10,000 – 23,000 on the scoville scale, your discretion is advised",
      "s": [10000, 23000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 0,
      "w_to": 41
    },
    "41": {
      "title": "Serrano Peppers Room",
      "description": "This room is listed at 10,000 – 23,000 on the scoville scale, your discretion is advised",
      "s": [10000, 23000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 0,
      "w_to": 42
    },
    "42": {
      "title": "Cayenne Peppers Room",
      "description": "This room is listed at 30,000 – 50,000 on the scoville scale, your discretion is advised",
      "s": [30000, 50000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 0,
      "w_to": 43
    },
    "43": {
      "title": "Jalapeno Room",
      "description": "This room is listed at 2,500 – 8,000 on the scoville scale, your discretion is advised",
      "s": [2500, 8000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 0,
      "w_to": 44
    },
    "44": {
      "title": "Chile de Arbol Peppers Room",
      "description": "This room is listed at 15,000 – 65,000 on the scoville scale, your discretion is advised",
      "s": [15000, 65000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 0,
      "w_to": 45
    },
    "45": {
      "title": "Habanero Peppers Room",
      "description": "This room is listed at 100,000 – 350,000 on the scoville scale, your discretion is advised",
      "s": [100000, 350000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 0,
      "w_to": 46
    },
    "46": {
      "title": "Cayenne Peppers Room",
      "description": "This room is listed at 30,000 – 50,000 on the scoville scale, your discretion is advised",
      "s": [30000, 50000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 0,
      "w_to": 47
    },
    "47": {
      "title": "Chile de Arbol Peppers Room",
      "description": "This room is listed at 15,000 – 65,000 on the scoville scale, your discretion is advised",
      "s": [15000, 65000],
      "n_to": 48,
      "s_to": 0,
      "e_to": 0,
      "w_to": 0
    },
    "48": {
      "title": "Cayenne Peppers Room",
      "description": "This room is listed at 30,000 – 50,000 on the scoville scale, your discretion is advised",
      "s": [30000, 50000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 49,
      "w_to": 0
    },
    "49": {
      "title": "Habanero Peppers Room",
      "description": "This room is listed at 100,000 – 350,000 on the scoville scale, your discretion is advised",
      "s": [100000, 350000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 50,
      "w_to": 0
    },
    "50": {
      "title": "Chile de Arbol Peppers Room",
      "description": "This room is listed at 15,000 – 65,000 on the scoville scale, your discretion is advised",
      "s": [15000, 65000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 51,
      "w_to": 0
    },
    "51": {
      "title": "Chile de Arbol Peppers Room",
      "description": "This room is listed at 15,000 – 65,000 on the scoville scale, your discretion is advised",
      "s": [15000, 65000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 52,
      "w_to": 0
    },
    "52": {
      "title": "Chiltepin Peppers Room",
      "description": "This room is listed at 50,000 – 100,000 on the scoville scale, your discretion is advised",
      "s": [50000, 100000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 53,
      "w_to": 0
    },
    "53": {
      "title": "Cayenne Peppers Room",
      "description": "This room is listed at 30,000 – 50,000 on the scoville scale, your discretion is advised",
      "s": [30000, 50000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 54,
      "w_to": 0
    },
    "54": {
      "title": "Chile de Arbol Peppers Room",
      "description": "This room is listed at 15,000 – 65,000 on the scoville scale, your discretion is advised",
      "s": [15000, 65000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 55,
      "w_to": 0
    },
    "55": {
      "title": "Cayenne Peppers Room",
      "description": "This room is listed at 30,000 – 50,000 on the scoville scale, your discretion is advised",
      "s": [30000, 50000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 56,
      "w_to": 0
    },
    "56": {
      "title": "Chile de Arbol Peppers Room",
      "description": "This room is listed at 15,000 – 65,000 on the scoville scale, your discretion is advised",
      "s": [15000, 65000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 57,
      "w_to": 0
    },
    "57": {
      "title": "Serrano Peppers Room",
      "description": "This room is listed at 10,000 – 23,000 on the scoville scale, your discretion is advised",
      "s": [10000, 23000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 58,
      "w_to": 0
    },
    "58": {
      "title": "Jalapeno Room",
      "description": "This room is listed at 2,500 – 8,000 on the scoville scale, your discretion is advised",
      "s": [2500, 8000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 59,
      "w_to": 0
    },
    "59": {
      "title": "Chiltepin Peppers Room",
      "description": "This room is listed at 50,000 – 100,000 on the scoville scale, your discretion is advised",
      "s": [50000, 100000],
      "n_to": 60,
      "s_to": 0,
      "e_to": 0,
      "w_to": 0
    },
    "60": {
      "title": "Jalapeno Room",
      "description": "This room is listed at 2,500 – 8,000 on the scoville scale, your discretion is advised",
      "s": [2500, 8000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 0,
      "w_to": 61
    },
    "61": {
      "title": "Serrano Peppers Room",
      "description": "This room is listed at 10,000 – 23,000 on the scoville scale, your discretion is advised",
      "s": [10000, 23000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 0,
      "w_to": 62
    },
    "62": {
      "title": "Carolina Reaper Chili Pepper Room",
      "description": "This room is listed at 2,200,000+ on the scoville scale, your discretion is advised",
      "s": [2200000, 5000000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 0,
      "w_to": 63
    },
    "63": {
      "title": "Habanero Peppers Room",
      "description": "This room is listed at 100,000 – 350,000 on the scoville scale, your discretion is advised",
      "s": [100000, 350000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 0,
      "w_to": 64
    },
    "64": {
      "title": "Ghost Peppers Room",
      "description": "This room is listed at 1,000,000 on the scoville scale, your discretion is advised",
      "s": [1000000, 1000000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 0,
      "w_to": 65
    },
    "65": {
      "title": "Jalapeno Room",
      "description": "This room is listed at 2,500 – 8,000 on the scoville scale, your discretion is advised",
      "s": [2500, 8000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 0,
      "w_to": 66
    },
    "66": {
      "title": "Chiltepin Peppers Room",
      "description": "This room is listed at 50,000 – 100,000 on the scoville scale, your discretion is advised",
      "s": [50000, 100000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 0,
      "w_to": 67
    },
    "67": {
      "title": "Serrano Peppers Room",
      "description": "This room is listed at 10,000 – 23,000 on the scoville scale, your discretion is advised",
      "s": [10000, 23000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 0,
      "w_to": 68
    },
    "68": {
      "title": "Chile de Arbol Peppers Room",
      "description": "This room is listed at 15,000 – 65,000 on the scoville scale, your discretion is advised",
      "s": [15000, 65000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 0,
      "w_to": 69
    },
    "69": {
      "title": "Chiltepin Peppers Room",
      "description": "This room is listed at 50,000 – 100,000 on the scoville scale, your discretion is advised",
      "s": [50000, 100000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 0,
      "w_to": 70
    },
    "70": {
      "title": "Habanero Peppers Room",
      "description": "This room is listed at 100,000 – 350,000 on the scoville scale, your discretion is advised",
      "s": [100000, 350000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 0,
      "w_to": 71
    },
    "71": {
      "title": "Jalapeno Room",
      "description": "This room is listed at 2,500 – 8,000 on the scoville scale, your discretion is advised",
      "s": [2500, 8000],
      "n_to": 72,
      "s_to": 0,
      "e_to": 0,
      "w_to": 0
    },
    "72": {
      "title": "Habanero Peppers Room",
      "description": "This room is listed at 100,000 – 350,000 on the scoville scale, your discretion is advised",
      "s": [100000, 350000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 73,
      "w_to": 0
    },
    "73": {
      "title": "Jalapeno Room",
      "description": "This room is listed at 2,500 – 8,000 on the scoville scale, your discretion is advised",
      "s": [2500, 8000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 74,
      "w_to": 0
    },
    "74": {
      "title": "Carolina Reaper Chili Pepper Room",
      "description": "This room is listed at 2,200,000+ on the scoville scale, your discretion is advised",
      "s": [2200000, 5000000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 75,
      "w_to": 0
    },
    "75": {
      "title": "Chiltepin Peppers Room",
      "description": "This room is listed at 50,000 – 100,000 on the scoville scale, your discretion is advised",
      "s": [50000, 100000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 76,
      "w_to": 0
    },
    "76": {
      "title": "Chile de Arbol Peppers Room",
      "description": "This room is listed at 15,000 – 65,000 on the scoville scale, your discretion is advised",
      "s": [15000, 65000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 77,
      "w_to": 0
    },
    "77": {
      "title": "Habanero Peppers Room",
      "description": "This room is listed at 100,000 – 350,000 on the scoville scale, your discretion is advised",
      "s": [100000, 350000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 78,
      "w_to": 0
    },
    "78": {
      "title": "Chile de Arbol Peppers Room",
      "description": "This room is listed at 15,000 – 65,000 on the scoville scale, your discretion is advised",
      "s": [15000, 65000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 79,
      "w_to": 0
    },
    "79": {
      "title": "Chile de Arbol Peppers Room",
      "description": "This room is listed at 15,000 – 65,000 on the scoville scale, your discretion is advised",
      "s": [15000, 65000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 80,
      "w_to": 0
    },
    "80": {
      "title": "Habanero Peppers Room",
      "description": "This room is listed at 100,000 – 350,000 on the scoville scale, your discretion is advised",
      "s": [100000, 350000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 81,
      "w_to": 0
    },
    "81": {
      "title": "Jalapeno Room",
      "description": "This room is listed at 2,500 – 8,000 on the scoville scale, your discretion is advised",
      "s": [2500, 8000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 82,
      "w_to": 0
    },
    "82": {
      "title": "Chiltepin Peppers Room",
      "description": "This room is listed at 50,000 – 100,000 on the scoville scale, your discretion is advised",
      "s": [50000, 100000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 83,
      "w_to": 0
    },
    "83": {
      "title": "Chiltepin Peppers Room",
      "description": "This room is listed at 50,000 – 100,000 on the scoville scale, your discretion is advised",
      "s": [50000, 100000],
      "n_to": 84,
      "s_to": 0,
      "e_to": 0,
      "w_to": 0
    },
    "84": {
      "title": "Chiltepin Peppers Room",
      "description": "This room is listed at 50,000 – 100,000 on the scoville scale, your discretion is advised",
      "s": [50000, 100000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 0,
      "w_to": 85
    },
    "85": {
      "title": "Jalapeno Room",
      "description": "This room is listed at 2,500 – 8,000 on the scoville scale, your discretion is advised",
      "s": [2500, 8000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 0,
      "w_to": 86
    },
    "86": {
      "title": "Jalapeno Room",
      "description": "This room is listed at 2,500 – 8,000 on the scoville scale, your discretion is advised",
      "s": [2500, 8000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 0,
      "w_to": 87
    },
    "87": {
      "title": "Habanero Peppers Room",
      "description": "This room is listed at 100,000 – 350,000 on the scoville scale, your discretion is advised",
      "s": [100000, 350000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 0,
      "w_to": 88
    },
    "88": {
      "title": "Carolina Reaper Chili Pepper Room",
      "description": "This room is listed at 2,200,000+ on the scoville scale, your discretion is advised",
      "s": [2200000, 5000000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 0,
      "w_to": 89
    },
    "89": {
      "title": "Carolina Reaper Chili Pepper Room",
      "description": "This room is listed at 2,200,000+ on the scoville scale, your discretion is advised",
      "s": [2200000, 5000000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 0,
      "w_to": 90
    },
    "90": {
      "title": "Chile de Arbol Peppers Room",
      "description": "This room is listed at 15,000 – 65,000 on the scoville scale, your discretion is advised",
      "s": [15000, 65000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 0,
      "w_to": 91
    },
    "91": {
      "title": "Ghost Peppers Room",
      "description": "This room is listed at 1,000,000 on the scoville scale, your discretion is advised",
      "s": [1000000, 1000000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 0,
      "w_to": 92
    },
    "92": {
      "title": "Carolina Reaper Chili Pepper Room",
      "description": "This room is listed at 2,200,000+ on the scoville scale, your discretion is advised",
      "s": [2200000, 5000000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 0,
      "w_to": 93
    },
    "93": {
      "title": "Habanero Peppers Room",
      "description": "This room is listed at 100,000 – 350,000 on the scoville scale, your discretion is advised",
      "s": [100000, 350000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 0,
      "w_to": 94
    },
    "94": {
      "title": "Carolina Reaper Chili Pepper Room",
      "description": "This room is listed at 2,200,000+ on the scoville scale, your discretion is advised",
      "s": [2200000, 5000000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 0,
      "w_to": 95
    },
    "95": {
      "title": "Serrano Peppers Room",
      "description": "This room is listed at 10,000 – 23,000 on the scoville scale, your discretion is advised",
      "s": [10000, 23000],
      "n_to": 96,
      "s_to": 0,
      "e_to": 0,
      "w_to": 0
    },
    "96": {
      "title": "Cayenne Peppers Room",
      "description": "This room is listed at 30,000 – 50,000 on the scoville scale, your discretion is advised",
      "s": [30000, 50000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 97,
      "w_to": 0
    },
    "97": {
      "title": "Carolina Reaper Chili Pepper Room",
      "description": "This room is listed at 2,200,000+ on the scoville scale, your discretion is advised",
      "s": [2200000, 5000000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 98,
      "w_to": 0
    },
    "98": {
      "title": "Habanero Peppers Room",
      "description": "This room is listed at 100,000 – 350,000 on the scoville scale, your discretion is advised",
      "s": [100000, 350000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 99,
      "w_to": 0
    },
    "99": {
      "title": "Ghost Peppers Room",
      "description": "This room is listed at 1,000,000 on the scoville scale, your discretion is advised",
      "s": [1000000, 1000000],
      "n_to": 0,
      "s_to": 0,
      "e_to": 0,
      "w_to": 0
    }
  }

  export default Rooms;